/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { MediaAudioHeadsetIcon16Light } from './MediaAudioHeadsetIcon16Light';
import { MediaAudioHeadsetIcon16Regular } from './MediaAudioHeadsetIcon16Regular';
import { MediaAudioHeadsetIcon16Solid } from './MediaAudioHeadsetIcon16Solid';
import { MediaAudioHeadsetIcon20Light } from './MediaAudioHeadsetIcon20Light';
import { MediaAudioHeadsetIcon20Regular } from './MediaAudioHeadsetIcon20Regular';
import { MediaAudioHeadsetIcon20Solid } from './MediaAudioHeadsetIcon20Solid';
import { MediaAudioHeadsetIcon24Regular } from './MediaAudioHeadsetIcon24Regular';
import { MediaAudioHeadsetIcon24Solid } from './MediaAudioHeadsetIcon24Solid';
import { MediaAudioHeadsetIcon32Regular } from './MediaAudioHeadsetIcon32Regular';
import { MediaAudioHeadsetIcon64Regular } from './MediaAudioHeadsetIcon64Regular';
var sizes = {
    16: {
        light: MediaAudioHeadsetIcon16Light,
        regular: MediaAudioHeadsetIcon16Regular,
        solid: MediaAudioHeadsetIcon16Solid,
    },
    20: {
        light: MediaAudioHeadsetIcon20Light,
        regular: MediaAudioHeadsetIcon20Regular,
        solid: MediaAudioHeadsetIcon20Solid,
    },
    24: {
        regular: MediaAudioHeadsetIcon24Regular,
        solid: MediaAudioHeadsetIcon24Solid,
    },
    32: {
        regular: MediaAudioHeadsetIcon32Regular,
    },
    64: {
        regular: MediaAudioHeadsetIcon64Regular,
    },
};
export var MediaAudioHeadsetIcon = forwardRef('MediaAudioHeadsetIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
